import * as React from 'react';

function SvgIconErrorSmall(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 14A7 7 0 117 0a7 7 0 010 14zM6.77 3a.77.77 0 00-.77.77v4.46c0 .426.344.77.77.77h.46A.77.77 0 008 8.23V3.77A.77.77 0 007.23 3h-.46zm0 7a.77.77 0 00-.77.77v.46c0 .426.344.77.77.77h.46a.77.77 0 00.77-.77v-.46a.77.77 0 00-.77-.77h-.46z"
        fill="#D95449"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgIconErrorSmall;
